import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


// @mui
import { LoadingButton } from "@mui/lab";
import {
  Alert, Box, Grid, IconButton,
  InputAdornment, Link,
  Stack, TextField
} from "@mui/material";
// components
import PostRequest from "../../../components/apiConnections/postRequest";
import Iconify from "../../../components/iconify";
import Loader from "../../../Loader";

// ----------------------------------------------------------------------

export default function RegistrationForm({ toggleTheme }) {
  const { enqueueSnackbar } = useSnackbar();
  const [theme, setTheme] = useState(localStorage.getItem('theme'));
  const navigate = useNavigate();
  const [showLoader, setshowLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [inputValues, setInputValues] = useState({
    firstName: "",
    lastName: "",
    company: "",
    domain: "",
    emailId: "",
    password: "",
    confirmPassword: ""

  });
  const [alertData, setAlertData] = useState({});



  const toggleModeButtonClick = () => {
    setTheme((theme === 'Dark') ? `Light` : `Dark`)
    toggleTheme();
  }

  useEffect(() => {
    if (alertData.showalert) {
      setTimeout(() => {
        setAlertData({});
      }, 2000);
    }
  }, [alertData]);

  const do_Register = async (e) => {
    e.preventDefault();
    setshowLoader(true);

    try {
      const { firstName, lastName, company, domain, emailId, password, confirmPassword } = inputValues;
      if (firstName === '' || firstName === undefined || lastName === '' || lastName === undefined || company === '') {
        enqueueSnackbar('Please fill all field.', { variant: 'error' });
        setshowLoader(false);
        return false;
      }
      // checkValidation();
      if (password === confirmPassword) {
        const payload = {
          firstName,
          lastName,
          company,
          domain,
          emailId,
          password,
          confirmPassword,
        };
        const registerResult = await PostRequest(
          `${process.env.REACT_APP_BACKEND_BASE_URL}${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_TP_REGISTRATION}`,
          payload
        );
        if (registerResult && registerResult.status === 200) {
          if (registerResult.data.code === 200) {
            enqueueSnackbar('Registration done successfully, for activation of account please check email inbox.', { variant: 'success' });
            setshowLoader(false);
            setTimeout(() => {
              navigate("/", { replace: true });
            }, 2000);

          }
          else {
            enqueueSnackbar(registerResult.data.message, { variant: 'error' });
            setshowLoader(false);
            return false;
          }
        } else {
          enqueueSnackbar(registerResult.data.message, { variant: 'error' });
          setshowLoader(false);
          return false;
        }
      } else {
        enqueueSnackbar('Password and confirm password not matched.', { variant: 'error' });
        setshowLoader(false);
        return false;
      }
    } catch (error) {
      enqueueSnackbar('Error in user Registration.', { variant: 'error' });
      setshowLoader(false);
      return false;
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputValues({ ...inputValues, [name]: value });
  };

  return (
    <>
      <Loader show={showLoader} />
      {alertData.showalert ? (
        <Alert sx={{ mb: 2 }} severity={alertData.alerttype}>
          {alertData.message}
        </Alert>
      ) : null}

      <Box
        component="form"
        sx={{
          '& .MuiTextField-root': { m: 1, width: '25ch', },
        }}
        noValidate
        autoComplete="off"
      >
        <div>
          <form onSubmit={(e) => do_Register(e)} className="relative">
            <div className="inputfield">
              <TextField
                name="firstName"
                onChange={handleChange}
                placeholder="First Name"
                defaultValue={inputValues.firstName}

              />
              <img src="/assets/user.svg" alt='user' />
            </div>
            <div className="inputfield">
              <TextField
                name="lastName"
                placeholder="Last Name"
                onChange={handleChange}
                defaultValue={inputValues.lastName}
              />
              <img src="/assets/user.svg" alt='user' />
            </div>
            <div className="inputfield">
              <TextField
                name="company"
                placeholder="Company Name"
                onChange={handleChange}
                defaultValue={inputValues.company}
              />
              <img src="/assets/company.svg" alt='user' />
            </div>
            <div className="inputfield">
              <TextField
                name="domain"
                placeholder="Domain Name"
                onChange={handleChange}
                defaultValue={inputValues.domain}
              />
              <img src="/assets/domain.svg" alt='user' />
            </div>
            <div className="inputfield">
              <TextField
                name="emailId"
                placeholder="Email address"
                onChange={handleChange}
                defaultValue={inputValues.emailId}

              />
              <img src="/assets/email-icon.svg" alt='email' />
            </div>

            <div className="inputfield">
              <TextField
                name="password"
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                onChange={handleChange}
                defaultValue={inputValues.password}

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className="eye-icon">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        <Iconify
                          icon={showPassword ? "eva:eye-fill" : "eva:eye-off-fill"}
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <img src="/assets/password-check.svg" alt='password' />
            </div>

            <div className="inputfield">
              <TextField
                name="confirmPassword"
                placeholder="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                onChange={handleChange}
                defaultValue={inputValues.confirmPassword}

                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" className="eye-icon">
                      <IconButton
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        edge="end"
                      >
                        <Iconify
                          icon={
                            showConfirmPassword
                              ? "eva:eye-fill"
                              : "eva:eye-off-fill"
                          }
                        />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <img src="/assets/password-check.svg" alt='password' />
            </div>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              sx={{ my: 2 }}
            >
              <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={(e) => do_Register(e)}
              >
                Sign Up
              </LoadingButton>
            </Stack>
            <Box>
              <Grid container sx={{ my: 2 }}>
                <Grid item xs className="already-have">
                  Already have an account?  <Link href="/" variant="body2"> Login here </Link>
                </Grid>
              </Grid>
            </Box>
            <FormControlLabel className="dark-toggle" control={<Switch checked={theme === "Dark"} onChange={() => toggleModeButtonClick()} />} label={`${theme} Mode `} />
          </form>
        </div>
      </Box>
    </>
  );
}
